import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAllResearchProposal = () => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.getAllResearchProposal();
  dispatch({
    type: TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const getFilteredResearchProposal = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.getFilteredResearchProposal(page, pageSize);
  dispatch({
    type: TYPE.RESEARCH_PROPOSAL.GET_FILTERED_RESEARCH_PROPOSAL_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.GET_FILTERED_RESEARCH_PROPOSAL_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.GET_FILTERED_RESEARCH_PROPOSAL_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const getAllResearchProposalByProfileId = (id) => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.getAllResearchProposalByProfileId(id);
  dispatch({
    type: TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const insertResearchProposal = (profileId, payload) => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.insertResearchProposal();
  dispatch({
    type: TYPE.RESEARCH_PROPOSAL.INSERT_RESEARCH_PROPOSAL_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.INSERT_RESEARCH_PROPOSAL_SUCCESS,
      id: profileId,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm dữ liệu thành công!",
      })
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.INSERT_RESEARCH_PROPOSAL_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Thêm dữ liệu thất bại!",
      })
    );
    return { success: false, data: null };
  }
};

export const updateResearchProposal = (id, payload) => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.updateResearchProposal(id);
  dispatch({
    type: TYPE.RESEARCH_PROPOSAL.UPDATE_RESEARCH_PROPOSAL_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.UPDATE_RESEARCH_PROPOSAL_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật dữ liệu thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.UPDATE_RESEARCH_PROPOSAL_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Cập nhật dữ liệu thất bại!",
      })
    );
    return false;
  }
};

export const deleteResearchProposal = (id) => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.deleteResearchProposal(id);
  dispatch({
    type: TYPE.RESEARCH_PROPOSAL.DELETE_RESEARCH_PROPOSAL_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.DELETE_RESEARCH_PROPOSAL_SUCCESS,
      id,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xoá dữ liệu thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.DELETE_RESEARCH_PROPOSAL_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xoá dữ liệu thất bại!",
      })
    );
    return false;
  }
};

// Sprint 2: admin "Yêu cầu khai lại" for research proposal.
export const requestRevisionResearchProposal = (id, reason) => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.requestRevisionResearchProposal(id);
  const { response, error } = await apiCall({ ...api, payload: { reason } });
  if (!error && response?.status === 200 && response.data?.success) {
    if (response.data.data) {
      dispatch({
        type: TYPE.RESEARCH_PROPOSAL.ACCEPT_RESEARCH_PROPOSAL_SUCCESS,
        payload: response.data.data,
        meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
      });
    }
    dispatch(notification({ type: 'success', message: 'Đã gửi yêu cầu khai lại' }));
    return true;
  }
  dispatch(notification({
    type: 'error',
    message: response?.data?.message || 'Yêu cầu khai lại thất bại',
  }));
  return false;
};

export const acceptResearchProposal = (id, accept) => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.acceptResearchProposal(id, accept);
  dispatch({
    type: TYPE.RESEARCH_PROPOSAL.ACCEPT_RESEARCH_PROPOSAL_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.ACCEPT_RESEARCH_PROPOSAL_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xác nhận thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.ACCEPT_RESEARCH_PROPOSAL_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xác nhận thất bại!",
      })
    );
    return false;
  }
};

export const getDuplicateResearchProposal = () => async (dispatch) => {
  const api = API_URLS.RESEARCH_PROPOSAL.getDuplicateResearchProposal();
  dispatch({
    type: TYPE.RESEARCH_PROPOSAL.GET_DUPLICATE_RESEARCH_PROPOSAL_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.GET_DUPLICATE_RESEARCH_PROPOSAL_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Lấy dữ liệu trùng thành công!" }));
  } else {
    dispatch({
      type: TYPE.RESEARCH_PROPOSAL.GET_DUPLICATE_RESEARCH_PROPOSAL_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_PROPOSAL, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Lấy dữ liệu trùng thất bại!" }));
  }
};

